import React from 'react';
import { Column, OverlayTrigger, PopOver, Table } from '@tencent/spaui';
import { leadsSubTypeTips } from '../../../../consts/Tips';
import { Tags } from '../../../../consts/Tags';

export const actionSubTypeRender = (type, name, value, data) => {
  if (type !== 'head') {
    let str = '';
    if (Tags.actionSubTypeTag[value]) {
      str = Tags.actionSubTypeTag[value];
    }
    if (data.leadsSubType !== undefined) {
      if (Tags.leadsSubTypeTag[data.leadsSubType]) {
        str += `-${Tags.leadsSubTypeTag[data.leadsSubType].desc}`;
      }
    }
    return str;
  }
  // return value;
  const popoverstyle = {
    maxWidth: '800px',
  };

  const popover = (
    <PopOver style={popoverstyle}>
      <div className="poptable">
        <Table hideThead={true} data={leadsSubTypeTips.tag}>
          <Column name="enumValue" minWidth={200}>
            枚举值
          </Column>
          <Column name="enumDetail">说明</Column>
        </Table>
      </div>
    </PopOver>
  );
  return (
    <div>
      {value}
      <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
        <i className="icon icon-help">
          <i></i>
        </i>
      </OverlayTrigger>
    </div>
  );
};
